import { ReactComponent as Account } from 'img/Icon_account.svg';
import { ReactComponent as General } from 'img/Icon_general.svg';
import { ReactComponent as Pacs } from 'img/Icon_pacs.svg';
import { ReactComponent as Setting } from 'img/header-setting.svg';
import { ReactComponent as Jobqueue } from 'img/Icon_jobqueue.svg';
// import './SettingsTab.scss';
import styles from './SettingsTab.module.scss';
import {
  TAB_CONTENT_MAPPING,
  TabContentMappingProps,
} from './tabContentMapping';
import { useAuthPage } from '@features/auth/useAuthPage';
import { useConfig } from 'config/useConfig';
import { useEffect, useMemo, useRef } from 'react';
import { store } from '@root/store';

export interface SettingsTabProps {
  activeTab: TabContentMappingProps;
  setActiveTab: (tabId: string) => void;
}

export const TAB_ICONS: Record<
  string,
  React.FC<React.SVGProps<SVGSVGElement>>
> = {
  general: General,
  pacsConnection: Pacs,
  account: Account,
  jobqueue: Jobqueue,
  settings: Setting,
};

const SETTINGS_TAB_TITLE = 'Setting';

const SettingsTab = ({ activeTab, setActiveTab }: SettingsTabProps) => {
  const { user } = useAuthPage();
  const { config, setData } = useConfig();
  const isAdmin = user?.role?.name === 'admin';
  const visibleTabs = useMemo(
    () =>
      Object.entries(TAB_CONTENT_MAPPING).filter(
        ([key]) => {
          if (isAdmin) {
            return true;
          }

          return key !== 'settings' && key !== 'jobqueue';
        },
      ),
    [isAdmin],
  );

  const generalSettingRef = useRef(store.getState().settings.data.general);
  useEffect(() => {
    const unsubscribe = store.subscribe(() => {
      generalSettingRef.current = store.getState().settings.data.general;
    });
    return unsubscribe;
  }, []);

  useEffect(() => {
    return () => {
      if (!generalSettingRef.current) return;
      setData({ generalSetting: generalSettingRef.current });
      if (
        config.generalSetting.renderingQuality !==
        generalSettingRef.current.renderingQuality
      ) {
        // console.log('바꿔야해 랜터퀄',generalSettingRef.current)

        //이거든 타임아웃이든 안하면 setData보다 빨리 꺼져버림.
        requestAnimationFrame(() => {
          window.location.reload();
        });
        // setTimeout(() => {
        // }, 550);
      }
    };
  }, []);

  return (
    <div className={styles.frame}>
      <div className={styles.title}>{SETTINGS_TAB_TITLE}</div>
      <div className={styles.menu}>
        {visibleTabs.map(([key, TabComponent]) => {
          const Icon = TAB_ICONS[key];
          return (
            <div
              key={key}
              className={`${styles.item} ${activeTab.id === TabComponent.id ? styles.active : ''}`}
              onClick={() => setActiveTab(TabComponent.id)}
            >
              <span className={styles.iconContainer}>
                <Icon />
              </span>
              <span className={styles.text}>{TabComponent.title}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SettingsTab;
